export default "__VITE_ASSET__DQxHd9T0__"